import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import { lisapropApi } from "configurations/AxiosConfig";
import VisitorLayout from "components/layouts/VisitorLayout";
import LoadingIcon from "assets/svg/lisapropFavicon.svg";

interface PrivateRouteProps {
  children: React.ReactNode;
}

const VisitorRouter: React.FC<PrivateRouteProps> = ({ children }) => {
  const { visitorSignedIn, setVisitorSignedIn, setLisapropVisitor } = useAuth();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [init, setInit] = useState(false); // Added to prevent multiple calls
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const userId = searchParams.get("userId");
  const accessCode = searchParams.get("accessCode");

  useEffect(() => {
    const handleLoginVisitor = async (userId: string, accessCode: string) => {
      try {
        const response = await lisapropApi.post(
          `visitor/authenticate`,
          {
            userId: userId,
            code: accessCode,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          setVisitorSignedIn(true);
          localStorage.setItem(
            "visitorDetails",
            JSON.stringify({
              firstName: response?.data?.data?.firstName,
              userId: response?.data?.data?.userId,
              monitoredProjectId: response?.data?.data?.monitoredProjectId,
            })
          );
          setLisapropVisitor(response.data.data);
        } else if (response.status === 401) {
          localStorage.removeItem("visitorDetails");
          setVisitorSignedIn(false);
          // navigate("/");
        }
      } catch (error: any) {
        console.error(error);
        localStorage.removeItem("visitorDetails");
        setVisitorSignedIn(false);
        // navigate("/");
      } finally {
        setLoading(false);
      }
    };

    if (!init) {
      setInit(true);
      const storedVisitorDetails = localStorage.getItem("visitorDetails");

      if (!storedVisitorDetails && userId && accessCode) {
        handleLoginVisitor(userId, accessCode);
      } else if (storedVisitorDetails) {
        const details = JSON.parse(storedVisitorDetails);
        setVisitorSignedIn(true);
        setLisapropVisitor(details);
        setLoading(false);
      } else {
        setLoading(false);
        // navigate("/");
      }
    }
  }, [
    userId,
    accessCode,
    init,
    navigate,
    setVisitorSignedIn,
    setLisapropVisitor,
  ]);

  if (loading) {
    return (
      <div className="w-[100%] h-[100vh] overflow-hidden flex items-center justify-center">
        <img
          src={LoadingIcon}
          className="suspense-loading-icon w-[80px] h-[80px]"
          alt="loading"
        />
      </div>
    );
  }

  if (visitorSignedIn) {
    return <VisitorLayout>{children}</VisitorLayout>;
  }

  return <div></div>;
  // return <Navigate to="/" />;
};

export default VisitorRouter;
